/**
 * Inspired from Material UI breakpoints (with less customization options)
 * documentation: https://material-ui.com/customization/breakpoints/
 * file: @material-ui/core/styles/createBreakpoints.js
 * */
const screenSizeKeys = ['xs', 'sm', 'md', 'lg', 'xl'];
export const screenSizes = {
    xs: 0,
    sm: 512,
    md: 768,
    lg: 1280,
    xl: 1920,
};
const down = (value) => {
    if (typeof value === 'number') {
        return `@media (max-width: ${value}px)`;
    }
    else if (value === 'xl') {
        return up('xs');
    }
    else {
        const maxWidthIndex = screenSizeKeys.indexOf(value) + 1;
        const upperBound = screenSizes[screenSizeKeys[maxWidthIndex]];
        return `@media (max-width: ${upperBound - 1}px)`;
    }
};
const up = (value) => {
    if (typeof value === 'number') {
        return `@media (min-width: ${value}px)`;
    }
    return `@media (min-width: ${screenSizes[value]}px)`;
};
const between = (startScreenSize, endScreenSize) => {
    var _a, _b;
    const minWidthSize = (_a = screenSizes[screenSizeKeys[screenSizeKeys.indexOf(startScreenSize)]]) !== null && _a !== void 0 ? _a : startScreenSize;
    const maxWidthSize = (_b = screenSizes[screenSizeKeys[screenSizeKeys.indexOf(endScreenSize)]]) !== null && _b !== void 0 ? _b : endScreenSize;
    return `@media (min-width: ${minWidthSize}px) and (max-width: ${maxWidthSize}px)`;
};
const only = (key) => {
    return between(key, key);
};
export const breakpoints = {
    up,
    down,
    only,
    between,
};
